import { CompanyTranslator } from 'src/translators'
import { UpdateCompanyAuthMethodFormEntity } from 'src/types'
import { useUpdateCompanyAuthMethodMutation } from 'src/types/generated'

export const useCompanyAuthMethod = () => {
  const [updateCompanyAuthMethodMutation] = useUpdateCompanyAuthMethodMutation()

  const updateCompanyAuthMethod = async (
    companyId: number,
    formEntity: UpdateCompanyAuthMethodFormEntity
  ): Promise<void> => {
    const input = CompanyTranslator.toUpdateCompanyAuthMethodRequest(formEntity)
    await updateCompanyAuthMethodMutation({ variables: { companyId, params: input } })
  }

  return {
    updateCompanyAuthMethod,
  }
}
